import styled from "styled-components";

const Container = styled.div``;
const Wrapper = styled.div``;

const Box = styled.div`
  display: flex;
  margin-bottom: min(2.94vw, 42px);
  gap: min(3.85vw, 55px);
  gap: 15px;
  padding: 15px;
  height: 200px;
  .link {
    margin-bottom: min(1.75vw, 25px);
  } 
  img {
    width: 320px;
    height: 100%;
    background: white;
  }
  .text-section {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    h4 {
      font-size: min(1.47vw, 19px);
      line-height: min(1.68vw, 24px);
      color: #ffffff;
      font-family: "robotobold";
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    p {
      font-size: min(1.19vw, 15px);
      line-height: min(1.61vw, 23px);
      font-family: "robotoregular";
      color: #ffffff;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    a {
      font-size: min(1.47vw, 15px);
      line-height: min(1.68vw, 24px);
      color: #ffffff;
      font-family: "robotobold";
    }
    a:hover {
      font-family: "robotobold";
      font-size: 16px;
      text-decoration: underline;
    }
  }


  @media (max-width: 767px) {
    height: 100px;
    padding: 10px;
    gap: 10px;
    img {
      width: 120px;
    }
    .text-section {
      img {
        width: 35vw;
        height: 21vw;
      }
      h4 {
        font-size: 2.94vw;
        line-height: 3.5vw;
        -webkit-line-clamp: 1;
      }
      p {
        font-size: 2.66vw;
        line-height: 3vw;
        -webkit-line-clamp: 3;
      }
      a {
        font-size: 2.66vw;
        margin-bottom: 0px;
      }
    }

  }
`;
export { Container, Wrapper, Box };
